var exports = {
  "S": "singleItem__n5Pk5F",
  "x": "multipleItems__D7DOUM",
};

module.exports = exports;
